/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KindEnum } from './kindEnum';


/**
 * One node of the variable tree; ``children`` nests further nodes.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface VariableNode { 
    key: string;
    label: string;
    kind: KindEnum;
    choices?: Array<string>;
    readonly children: Array<VariableNode>;
}
export namespace VariableNode {
}

export const VariableNode_key_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const VariableNode_label_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const VariableNode_kind_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const VariableNode_choices_Validators: ValidatorFn[] =
    [ ];

export const VariableNode_children_Validators: ValidatorFn[] =
    [  Validators.required, ];


